import Vue from "vue";
import VueRouter from "vue-router";
// import Main from "../views/MainPage.vue";
import Status from "../views/StatusPage.vue";
import Login from "../views/LoginPage.vue";
import Main from "../views/MainPage.vue";
import ChangePassword from "@/components/MainPage/ChangePassword.vue";
import MFASetup from "@/components/MainPage/SetupMFA.vue";
import store from "../store";
import NewUserWorkFlow from "../views/NewUserFlow.vue";
import Workspace from "@/components/Workspace.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    props: true,
    component: Login,
  },
  {
    path: "/",
    name: "main",
    props: true,
    component: Main,
    meta: { requiresAuth: true },
  },
  {
    path: "/status",
    name: "status",
    props: true,
    component: Status,
    meta: { requiresAuth: true },
  },
  {
    path: "/change-password",
    name: "changePassword",
    props: true,
    component: ChangePassword,
    meta: { requiresAuth: true },
  },
  {
    path: "/mfa-setup",
    name: "mfaSetup",
    props: true,
    component: MFASetup,
    meta: { requiresAuth: true },
  },
  {
    path: "/init-user",
    name: "InitUser",
    props: true,
    component: NewUserWorkFlow,
    meta: { requiresAuth: true },
  },
  {
    path: "/workspace",
    name: "workspace",
    props: true,
    component: Workspace,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const loggedIn = await store.dispatch("checkIfLoggedIn");

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Before rendering check if user is validated, and redirect to login page if not
    if (!loggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else if (to.name === "login") {
    // redirect user if they are already logged in
    loggedIn ? next({ path: "/" }) : next();
  } else {
    next();
  }
});

export default router;
